/* __next_internal_client_entry_do_not_use__ StyledComponentsRegistry auto */ import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useServerInsertedHTML } from "next/navigation";
import React, { useContext, useLayoutEffect, useState } from "react";
import { ServerStyleSheet, StyleSheetManager, StyleSheetContext } from "styled-components";
/**
 * On the server, inserts styled-component styles into the document.
 */ export var StyledComponentsRegistry = function(param) {
    var children = param.children;
    // Only create stylesheet once with lazy initial state
    // x-ref: https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
    var _useState = _sliced_to_array(useState(function() {
        return new ServerStyleSheet();
    }), 1), styledComponentsStyleSheet = _useState[0];
    var _useContext = useContext(StyleSheetContext), clientStyleSheet = _useContext.styleSheet;
    useLayoutEffect(function() {
        // eslint-disable-next-line @faire/ssr-no-restricted-globals
        window.SS_SC = clientStyleSheet;
        clientStyleSheet.rehydrate();
    }, [
        clientStyleSheet
    ]);
    // eslint-disable-next-line @faire/no-inline-hoc-fc -- false positive
    useServerInsertedHTML(function() {
        var elements = styledComponentsStyleSheet.getStyleElement();
        styledComponentsStyleSheet.instance.clearTag();
        var modifiedElements = elements.map(function(element, index) {
            return /*#__PURE__*/ _jsxs(React.Fragment, {
                children: [
                    element,
                    /*#__PURE__*/ _jsx("script", {
                        /* eslint-disable-next-line react/no-danger */ dangerouslySetInnerHTML: {
                            // eslint-disable-next-line @faire/no-dollar-symbol-in-strings
                            __html: "var _window$SS_SC, _window$SS_SC$rehydra;\n            (_window$SS_SC = window.SS_SC) === null || _window$SS_SC === void 0 || (_window$SS_SC$rehydra = _window$SS_SC.rehydrate) === null || _window$SS_SC$rehydra === void 0 ? void 0 : _window$SS_SC$rehydra.call(_window$SS_SC);"
                        }
                    })
                ]
            }, "serverstylesheet-style-".concat(index));
        });
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: modifiedElements
        });
    });
    // eslint-disable-next-line @faire/ssr-no-restricted-globals
    if ("object" !== "undefined") {
        return /*#__PURE__*/ _jsx(StyleSheetManager, {
            enableVendorPrefixes: true,
            children: children
        });
    }
    return /*#__PURE__*/ _jsx(StyleSheetManager, {
        enableVendorPrefixes: true,
        sheet: styledComponentsStyleSheet.instance,
        children: children
    });
};
